<div>
  <div>
    <h4>Crew Log</h4>
  </div>
  <div id="datePicker">
    <label for="startDate">Date: &nbsp;</label>
    <p-datepicker id="startDate" [(ngModel)]="date" [showIcon]="true" (ngModelChange)="onDateChange()" ></p-datepicker>
  </div>

  <hr>

    @if (scheduledBuckets?.length > 0) {
      <div class="p-grid">
        @for (scheduledBucket of scheduledBuckets; track scheduledBucket; let i = $index) {
          <div class="p-col-12">
            <div>
              <h5>Crew {{i + 1}}: {{scheduledBucket.employeeString}} ({{scheduledBucket.equipmentString}})</h5>
              <p-button type="button" label="Map Route" (click)="exportToGoogle(scheduledBucket)" severity="info"></p-button>
              @for (workOrder of scheduledBucket.workOrders; track workOrder) {
                <div [ngClass]="workOrder.allScheduledTasksComplete ? 'grey-out' : ''">
                  @if (workOrder.allScheduledTasksComplete) {
                    <span><i class="pi pi-check"></i></span>
                  }
                  <a target="_blank" class="regular-link" [routerLink]="workOrder.workOrderLink">{{workOrder.quoteNumber}}</a> -
                  <a target="_blank" class="regular-link" [routerLink]="workOrder.customerLink">{{workOrder.customerName}}</a> -
                  {{workOrder.customerPhone | phoneNumber}} -
                  {{workOrder.workOrderAddress}}
                  @if (!workOrder.hidePrice || canSeeHiddenPrices) {
                    <span> - {{workOrder.priceSummary | currency }} - {{workOrder.hoursSummary}} hour@if (workOrder.hoursSummary != 1) {
                      <span>s</span>
                    }</span>
                  }
                  @if (workOrder.hasGoBack) {
                    <span> - GB</span>
                  }
                  <span> - {{workOrder.tasks}}</span>
                </div>
              }
              <div class="bold">
                {{scheduledBucket.total | currency}} | {{scheduledBucket.hours}} hour@if (scheduledBucket.hours != 1) {
                <span>s</span>
              }
            </div>
          </div>
          <hr/>
        </div>
      }
    </div>
  }
  @if (!isLoading && !isLoadingMultiday  && scheduledBuckets.length <= 0) {
    <div class="fine-print">There are no crews scheduled for this day.</div>
  }
  <div>
    @if (isLoading || isLoadingMultiday) {
      <span style="margin-left:8px">
        <i class="pi pi-spin pi-spinner" style="font-size: 3.5em"></i>
      </span>
    }
  </div>
</div>